import { UI } from '../../../core/static/js/helpers/UI.js'

const mainUI = {
  body: document.querySelector("body")
}

var jumpToAnchor = function (element) { //Smooth scroll #div
  window.scroll({
    behavior: 'smooth',
    left: 0,
    top: element.offsetTop
  });
}

var singlePageSpecialNav = function () {  //Bottom Scrolly Nav
  if (mainUI.body.classList.contains('single-shop-special')) {
    let scrollyNav = UI.find('#scrollyNav');
    let scrollyWrapper = UI.find('#scrollyNav .scrollable');
    if (scrollyNav && scrollyWrapper){
      let y = window.scrollY;
      let x = document.documentElement.scrollHeight / scrollyWrapper.scrollWidth;
      scrollyNav.scrollLeft = y/x;
    }
  }
}
var singlePageReverseNav = function () {  //Bottom Scrolly Nav
  if (mainUI.body.classList.contains('single-shop-special')) {
    let scrollyNav = UI.find('#scrollyNav');
    let y = window.scrollY;
    if (scrollyNav){
      if ( y > 0 ){
        scrollyNav.classList.remove('reverse');
      } else {
        scrollyNav.classList.add('reverse');
      }
    }
  }
}

var singlePageStickyBlock = function () { //Stick left hero while right keeps scrolling
  if (mainUI.body.classList.contains('single-shop-special')) {
    let productBlocks = UI.findAll('.product-block-special');
    if (productBlocks){
      for (let i = 0; i < productBlocks.length; i++) {
        var productBlock = productBlocks[i];
        var x = productBlock.offsetTop;
        var y = x + productBlock.offsetHeight - window.innerHeight;
        var scrollPos = window.scrollY;
        var hero = productBlock.querySelector('.hero')
        if ( scrollPos > x && scrollPos < y ){
          hero.classList.add('fixed');
        } else {
          hero.classList.remove('fixed')
          if ( scrollPos > y ){
            hero.classList.add('fixed-bottom')
          } else {
            hero.classList.remove('fixed-bottom');
          }
        }
      }
    }
  }
}

var toggleProductBlock = function (el) { //Collapse product blocks
  let parentBlock = el.parentNode;
  let detailsBlock = parentBlock.querySelector('section.details');
  let collapseBtn = parentBlock.querySelector('.collapse-button');
  if (detailsBlock){
    if ( detailsBlock.classList.contains('collapsible') ){
      detailsBlock.classList.remove('collapsible');
      collapseBtn.classList.add('close');
    } else {
      detailsBlock.classList.add('collapsible');
      collapseBtn.classList.remove('close');
    }
  }
}

function attachEventListeners() { //Attach Events
  
//  let productAnchors = document.querySelectorAll('#scrollyNav a'); //Event on Bottom Nav anchors
//  if (productAnchors) {
//    for (var i = 0; i < productAnchors.length; i++) {
//      productAnchors[i].addEventListener('click', function (event) {
//        event.preventDefault();
//        let link = productAnchors[i].getAttribute("href");
//        let el = document.getElementById(link)
//        jumpToAnchor(el);
//      });
//    }
//  }
  
//  var collapseBtns = document.querySelectorAll(".single-shop-special .product-block-special .hero"); //Toggle Details Block
//  if (collapseBtns) {
//    for (let collapseBtn of collapseBtns) {
//      collapseBtn.addEventListener('click', function (event) {
//        event.preventDefault();
//        toggleProductBlock( collapseBtn );
//      });
//    }
//  }
}

window.addEventListener('scroll', function () { //Scroll Events
  singlePageSpecialNav();
  //singlePageReverseNav();
  singlePageStickyBlock();
});

window.addEventListener('resize', function () { //Resize Events
  singlePageSpecialNav();
  //singlePageReverseNav();
  singlePageStickyBlock();
});

window.addEventListener('DOMContentLoaded', function () { //OnLoad Events
  attachEventListeners();
});
